import { render, staticRenderFns } from "./guangzEditClass.vue?vue&type=template&id=a5ed4f94&scoped=true"
import script from "./guangzEditClass.vue?vue&type=script&lang=js"
export * from "./guangzEditClass.vue?vue&type=script&lang=js"
import style0 from "./guangzEditClass.vue?vue&type=style&index=0&id=a5ed4f94&prod&lang=less"
import style1 from "./guangzEditClass.vue?vue&type=style&index=1&id=a5ed4f94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ed4f94",
  null
  
)

export default component.exports